function getLocalStorage() {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function getItem(key) {
  try {
    const value = getLocalStorage()?.getItem(key);
    return value == null ? null : value;
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    getLocalStorage()?.setItem(key, String(value));
  } catch {
    // Storage may be denied (incognito + blocked site data) or full.
  }
}

export function removeItem(key) {
  try {
    getLocalStorage()?.removeItem(key);
  } catch {
    // no-op
  }
}
